import T from 'prop-types';

const TaskShape = {
    id: T.string,
    taskId: T.string,
    institutionId: T.string,
    typeName: T.string,
    actionName: T.string,
    actionKey: T.string,
    statement: T.string,
    title: T.string,
    sentFrom: T.string,
    sentBy: T.string,
    sentDate: T.string,
    type: T.string
};

const ACTIONS = {
    CHANGE_VIEW: 'CHANGE_VIEW',
    MARK_TASK_AS_READ: 'MARK_TASK_AS_READ',
    RESET_STATE: 'RESET_STATE',
    RESET_STATE_TASK_DETAIL: 'RESET_STATE_TASK_DETAIL',
    SET_TASK_DETAIL: 'SET_TASK_DETAIL',
    SET_TASKS: 'SET_TASKS',
    SET_TASKS_COUNT: 'SET_TASKS_COUNT',
    SET_MY_TASKS_STUDY_BINDER_NAMES: 'SET_MY_TASKS_STUDY_BINDER_NAMES',
    SET_TASKS_FETCHING: 'SET_TASKS_FETCHING',
    SET_TASKS_SIGNING: 'SET_TASKS_SIGNING',
    SET_TASK_DETAIL_FETCHING: 'SET_TASK_DETAIL_FETCHING',
    SET_TASK_FOR_DETAIL_DISPLAY: 'SET_TASK_FOR_DETAIL_DISPLAY',
    SET_TASK_FOR_SINGLE_SIGN: 'SET_TASK_FOR_SINGLE_SIGN',
    SUBMIT_SIGN_TASKS_COMPLETION: 'SUBMIT_SIGN_TASKS_COMPLETION',
    TOGGLE_TASK_FOR_MULTI_SIGN: 'TOGGLE_TASK_FOR_MULTI_SIGN',
    TASK_WINDOW_DETAIL: 'TASK_WINDOW_DETAIL',
    TASK_WINDOW_SHOW_ON_LOAD_TASK: 'TASK_WINDOW_SHOW_ON_LOAD_TASK'
};

const READ_AND_ACKNOWLEDGE_ID = 'read_and_acknowledge';

const ROW_TYPES = {
    DATE: 'DATE',
    DATETIME: 'DATETIME',
    DATE_NO_TZ: 'DATE_NO_TZ',
    RICH_TEXT: 'RICH_TEXT',
    LIST: 'LIST',
    LINK: 'LINK'
};

const TASK_TYPES = {
    DOA: 'doa',
    EVENT: 'event',
    SDFA: 'task'
};

const VIEWS = {
    DOCUMENT_DETAIL: 'DOCUMENT_DETAIL',
    TASK_DETAIL: 'TASK_DETAIL',
    TASK_LIST: 'TASK_LIST',
    TASK_SIGNATURE: 'TASK_SIGNATURE'
};

const ACTION_TEXT = 'Sign and Complete Tasks';

export { TaskShape, ACTIONS, READ_AND_ACKNOWLEDGE_ID, ROW_TYPES, TASK_TYPES, VIEWS, ACTION_TEXT };
